import { render, staticRenderFns } from "./TransactionProfileLocationInfo.vue?vue&type=template&id=52fbe6f2&scoped=true&"
import script from "./TransactionProfileLocationInfo.vue?vue&type=script&lang=js&"
export * from "./TransactionProfileLocationInfo.vue?vue&type=script&lang=js&"
import style0 from "./TransactionProfileLocationInfo.vue?vue&type=style&index=0&id=52fbe6f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbe6f2",
  null
  
)

export default component.exports